import { ResponseChatsWithMeta } from "@sms/shared/chat/chat.interface";

import { socketChats } from "./chat.sockets";

const fetchList: (data: {
  countChats: number;
  page: number | undefined;
}) => Promise<ResponseChatsWithMeta> = async (data: { countChats: number; page: number | undefined }) => {
  return (await socketChats.emitWithAck("fetchList", data)) as ResponseChatsWithMeta;
};

const fetchCountAllNotifications: () => Promise<number> = async () =>
  (await socketChats.emitWithAck("fetchCountAllNotifications")) as number;

export default { fetchList, fetchCountAllNotifications };
